/**
 * ============================================================================
 * COOKIE CONSENT MANAGER v1.0
 * ============================================================================
 *
 * Zentrale Verwaltung der Cookie-Einwilligungen (DSGVO-konform)
 *
 * Features:
 * - Speichert Einwilligung in localStorage
 * - Prüft Analytics-Consent vor jedem Tracking
 * - Ermöglicht Widerruf der Einwilligung
 *
 * @version 1.0.0
 */

const STORAGE_KEYS = {
  COOKIE_CONSENT: 'planivio_cookie_consent',
  ANALYTICS_CONSENT: 'planivio_analytics_consent',
  CONSENT_DATE: 'planivio_cookies_date'
};

/**
 * Prüft ob Analytics-Tracking erlaubt ist
 * @returns {boolean} true wenn Analytics akzeptiert wurde
 */
export function hasAnalyticsConsent() {
  const consent = localStorage.getItem(STORAGE_KEYS.ANALYTICS_CONSENT);
  return consent === 'accepted';
}

/**
 * Prüft ob der User bereits eine Entscheidung getroffen hat
 * @returns {boolean} true wenn bereits eine Entscheidung vorliegt
 */
export function hasConsent() {
  return !!localStorage.getItem(STORAGE_KEYS.COOKIE_CONSENT);
}

/**
 * Gibt die aktuelle Consent-Einstellung zurück
 * @returns {'all'|'essential'|null}
 */
export function getConsentLevel() {
  return localStorage.getItem(STORAGE_KEYS.COOKIE_CONSENT);
}

/**
 * Setzt Analytics-Consent auf "akzeptiert"
 */
export function acceptAnalytics() {
  localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, 'all');
  localStorage.setItem(STORAGE_KEYS.ANALYTICS_CONSENT, 'accepted');
  localStorage.setItem(STORAGE_KEYS.CONSENT_DATE, new Date().toISOString());
  console.log('✅ Analytics Consent: ACCEPTED');
}

/**
 * Setzt Analytics-Consent auf "abgelehnt"
 */
export function rejectAnalytics() {
  localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, 'essential');
  localStorage.setItem(STORAGE_KEYS.ANALYTICS_CONSENT, 'rejected');
  localStorage.setItem(STORAGE_KEYS.CONSENT_DATE, new Date().toISOString());
  console.log('✅ Analytics Consent: REJECTED');
}

/**
 * Widerruft die Analytics-Einwilligung (Opt-Out)
 */
export function revokeAnalyticsConsent() {
  localStorage.setItem(STORAGE_KEYS.COOKIE_CONSENT, 'essential');
  localStorage.setItem(STORAGE_KEYS.ANALYTICS_CONSENT, 'rejected');
  console.log('🔒 Analytics Consent: REVOKED');
}

/**
 * Setzt alle Consent-Einstellungen zurück (Cookie-Banner wird wieder angezeigt)
 */
export function resetConsent() {
  localStorage.removeItem(STORAGE_KEYS.COOKIE_CONSENT);
  localStorage.removeItem(STORAGE_KEYS.ANALYTICS_CONSENT);
  localStorage.removeItem(STORAGE_KEYS.CONSENT_DATE);
  console.log('🔄 Cookie Consent: RESET');
}

/**
 * Gibt Consent-Informationen für Debugging zurück
 */
export function getConsentInfo() {
  return {
    consentLevel: getConsentLevel(),
    analyticsConsent: hasAnalyticsConsent(),
    consentDate: localStorage.getItem(STORAGE_KEYS.CONSENT_DATE),
    hasDecided: hasConsent()
  };
}

export default {
  hasAnalyticsConsent,
  hasConsent,
  getConsentLevel,
  acceptAnalytics,
  rejectAnalytics,
  revokeAnalyticsConsent,
  resetConsent,
  getConsentInfo
};
